import React from 'react';
import Dropzone from 'react-dropzone';
import { useT } from 'client/i18n/hooks/useT';
import {
  ContentWrapper,
  IdleStateWrapper,
  UploaderHeading,
  UploaderLabel,
  UploaderLink,
} from './styles';
import {
  ACCEPTED_FILE_TYPES_AUDIO_USERS,
  ACCEPTED_FILE_TYPES_VIDEO_USERS,
  DROPZONE_COPY_AUDIO_USERS,
  DROPZONE_COPY_VIDEO_USERS,
} from '../constants';

type IdleStateProps = {
  onUploadFile: (uploadedFile: File) => void;
  onUploadUnsupportedFile: () => void;
  onDragEnter: () => void;
  onDragLeave: () => void;
  isVideoPodcaster: boolean;
};

export const IdleState = ({
  onUploadFile,
  onUploadUnsupportedFile,
  onDragEnter,
  onDragLeave,
  isVideoPodcaster,
}: IdleStateProps) => {
  const t = useT();

  const openFilePicker = (e: React.FormEvent, open: () => void) => {
    e.preventDefault();
    open();
  };

  const handleOnDrop = (acceptedFiles: File[]) => {
    onDragLeave();
    onUploadFile(acceptedFiles[0]);
  };

  return (
    <IdleStateWrapper>
      <Dropzone
        onDropAccepted={handleOnDrop}
        onDropRejected={onUploadUnsupportedFile}
        accept={
          isVideoPodcaster
            ? ACCEPTED_FILE_TYPES_VIDEO_USERS
            : ACCEPTED_FILE_TYPES_AUDIO_USERS
        }
        noClick
        noKeyboard
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        maxFiles={1}
      >
        {({ getRootProps, getInputProps, open }) => {
          return (
            <ContentWrapper {...getRootProps()} data-testid="dropzone">
              <input {...getInputProps()} />
              <div>
                <UploaderHeading>
                  {t(
                    'EpisodeOptionsScreen.EpisodeContent.IdleState.Header',
                    'Drag & drop files here to upload, or {uploaderLink}.',
                    'File dropzone message',
                    {
                      uploaderLink: (
                        <UploaderLink onClick={e => openFilePicker(e, open)}>
                          {t(
                            'EpisodeOptionsScreen.EpisodeContent.IdleState.BrowseFilesLinkText',
                            'browse',
                            'Browse files link text'
                          )}
                        </UploaderLink>
                      ),
                    }
                  )}
                </UploaderHeading>
                <UploaderLabel>
                  {t(
                    'EpisodeOptionsScreen.EpisodeContent.IdleState.FileExtensionsSupportedMessage',
                    'Supports {fileExtensions}',
                    'File dropzone supported formats message. fileExtensions is a list of formats like: mp3, m4a, wav, aif, mp4, mov',
                    {
                      fileExtensions: isVideoPodcaster
                        ? DROPZONE_COPY_VIDEO_USERS
                        : DROPZONE_COPY_AUDIO_USERS,
                    }
                  )}
                </UploaderLabel>
              </div>
            </ContentWrapper>
          );
        }}
      </Dropzone>
    </IdleStateWrapper>
  );
};
